import { createSelector } from 'reselect'

export const getInquiryConfirmation = createSelector(
  state => (state && state.checkRegistrationCost && state.checkRegistrationCost.inquiryConfirmation ? state.checkRegistrationCost.inquiryConfirmation : null),
  inquiryConfirmation => inquiryConfirmation
)
